var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLtoeViewAssignmentsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.9 57.2",
    style: {
      enableBackground: "new 0 0 64.9 57.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E5F1FA;}\n\t.st1{fill:#BFDDF1;}\n\t.st2{fill:#7FBAE3;}\n\t.st3{fill:#EF6552;}\n\t.st4{fill:#2A3953;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2187",
    transform: "translate(-2453.058 -3812.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2172",
    transform: "translate(2454.28 3826.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1477",
    className: "st0",
    d: "M5,0h52.5c2.8,0,5,2.2,5,5v31.3c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5C0,2.2,2.2,0,5,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2173",
    transform: "translate(2507.394 3826.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    className: "st1",
    d: "M5.2,0H0v41.3h5.2c2.3,0,4.2-1.9,4.2-4.2l0,0V4.2C9.4,1.9,7.5,0,5.2,0L5.2,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2175",
    transform: "translate(2473.357 3813.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2174",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    className: "st2",
    d: "M25.7,13.4h-5.1V7.2c0-1.1-0.9-2.1-2.1-2.1H7.2C6,5.1,5.1,6,5.1,7.2v6.3H0V7.2 C0,3.2,3.2,0,7.2,0h11.4c3.9,0,7.1,3.2,7.2,7.2L25.7,13.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2176",
    transform: "translate(2463.213 3836.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1478",
    className: "st2",
    d: "M0,0h10.2l0,0l0,0c0,2.6-2.1,4.8-4.8,4.8l0,0H4.8C2.1,4.8,0,2.6,0,0L0,0L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2177",
    transform: "translate(2499.032 3836.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1479",
    className: "st2",
    d: "M0,0h10.2l0,0l0,0c0,2.6-2.1,4.8-4.8,4.8l0,0H4.8C2.1,4.8,0,2.6,0,0L0,0L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2180",
    transform: "translate(2474.915 3841.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2178",
    transform: "translate(1.222 1.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    className: "st3",
    d: "M18.8,6.2h-6.2V0H6.2v6.2H0v6.4h6.2v6.2h6.4v-6.2h6.2V6.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    className: "st4",
    d: "M13.8,21.2H7.4c-0.7,0-1.2-0.5-1.2-1.2v-5h-5C0.5,15,0,14.5,0,13.8V7.4 c0-0.7,0.5-1.2,1.2-1.2h4.9v-5C6.2,0.5,6.7,0,7.4,0h6.4C14.5,0,15,0.5,15,1.2v4.9h5c0.7,0,1.2,0.5,1.2,1.2v6.4 c0,0.7-0.5,1.2-1.2,1.2h-5V20C15,20.7,14.5,21.2,13.8,21.2z M8.6,18.8h4v-4.9c0-0.7,0.5-1.2,1.2-1.2h4.9v-4h-4.9 c-0.7,0-1.2-0.5-1.2-1.2V2.4h-4v4.9c0,0.7-0.5,1.2-1.2,1.2h-5v4h4.9c0.7,0,1.2,0.5,1.2,1.2L8.6,18.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2181",
    transform: "translate(2453.058 3825.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    className: "st4",
    d: "M59.5,43.7H5.4c-3,0-5.4-2.4-5.4-5.4V5.4C0,2.4,2.4,0,5.4,0h54.1c3,0,5.4,2.4,5.4,5.4v32.9 C64.9,41.3,62.5,43.7,59.5,43.7z M5.4,2.4c-1.6,0-3,1.3-3,3v32.9c0,1.6,1.3,3,3,3h54.1c1.6,0,3-1.3,3-3V5.4c0-1.6-1.3-3-3-3H5.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2183",
    transform: "translate(2472.135 3812.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2182",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    className: "st4",
    d: "M26.9,15.9h-5.1c-0.7,0-1.2-0.5-1.2-1.2V8.4c0-0.5-0.4-0.8-0.8-0.8H8.4 C7.9,7.6,7.6,8,7.6,8.4v6.3c0,0.7-0.5,1.2-1.2,1.2H1.2c-0.7,0-1.2-0.5-1.2-1.2V8.4C0,3.8,3.8,0,8.4,0h11.4c4.6,0,8.4,3.8,8.4,8.4 v6.3C28.1,15.3,27.6,15.9,26.9,15.9z M23,13.4h2.6v-5c0-3.3-2.7-5.9-5.9-5.9H8.4c-3.3,0-5.9,2.7-5.9,5.9v5.1h2.6V8.4 c0-1.8,1.5-3.3,3.3-3.3h11.4c1.8,0,3.3,1.5,3.3,3.3L23,13.4L23,13.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2184",
    transform: "translate(2453.058 3835.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    className: "st4",
    d: "M63.7,2.4H1.2C0.5,2.4,0,1.9,0,1.2S0.5,0,1.2,0h62.5c0.7,0,1.2,0.5,1.2,1.2S64.4,2.4,63.7,2.4 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2185",
    transform: "translate(2461.991 3835.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    className: "st4",
    d: "M9.4,7.2H3.2C1.5,7.2,0,5.8,0,4V1.2C0,0.5,0.5,0,1.2,0h10.2c0.7,0,1.2,0.5,1.2,1.2V4 C12.6,5.8,11.2,7.2,9.4,7.2z M2.4,2.4V4c0,0.4,0.4,0.8,0.8,0.8l0,0h6.1c0.4,0,0.8-0.4,0.8-0.8l0,0V2.4H2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2186",
    transform: "translate(2497.81 3835.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    className: "st4",
    d: "M9.4,7.2H3.2C1.5,7.2,0,5.8,0,4V1.2C0,0.5,0.5,0,1.2,0h10.2c0.7,0,1.2,0.5,1.2,1.2V4 C12.6,5.8,11.2,7.2,9.4,7.2z M2.4,2.4V4c0,0.4,0.4,0.8,0.8,0.8l0,0h6.1c0.4,0,0.8-0.4,0.8-0.8l0,0V2.4H2.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtoeViewAssignmentsIcon);
export default __webpack_public_path__ + "static/media/ltoe-view-assignments-icon.9d3c42ca67dbda9bb0e9678dd5239b14.svg";
export { ForwardRef as ReactComponent };